export interface EmailInput {
  [key: string]: {
    value: string;
    error: any;
  };
}

export const emailInput = () => {
  return {
    email: {
      value: "",
      error: "",
    },
  } as EmailInput;
};

